import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { GroupEffects } from './member-group.effects';
import { memberGroupReducer } from './member-group.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('memberGroups', memberGroupReducer),
    EffectsModule.forFeature([GroupEffects]),
  ],
  providers: [],
})
export class MemberGroupStoreModule {}
